import React from "react";
import Input from "../form-input/input";
import { FormContext } from "../../dynamic-form/dynamic-form-context";

export default function Cnpj({ metadata }) {

    function isValidCnpjAlfanumerico(cnpj) {
        if (!cnpj) return false;

        const clean = cnpj.replace(/[^A-Za-z0-9]/g, "").toUpperCase();

        if (clean.length !== 14) return false;

        if (!/^[A-Z0-9]{12}[0-9]{2}$/.test(clean)) {
            return false;
        }

        const body = clean.substring(0, 12);
        const dvInformado = clean.substring(12);

        const pesos1 = [5,4,3,2,9,8,7,6,5,4,3,2];
        const pesos2 = [6,5,4,3,2,9,8,7,6,5,4,3,2];

        function charValue(char) {
            // 0-9
            if (char >= "0" && char <= "9") {
                return Number(char);
            }

            // A-Z
            return char.charCodeAt(0) - 48;
        }

        function calculaDV(texto, pesos) {
            let soma = 0;

            for (let i = 0; i < pesos.length; i++) {
                soma += charValue(texto[i]) * pesos[i];
            }

            const resto = soma % 11;

            return resto < 2 ? 0 : 11 - resto;
        }

        const dv1 = calculaDV(body, pesos1);
        const dv2 = calculaDV(body + dv1, pesos2);

        return dvInformado === `${dv1}${dv2}`;
    }

    const { formValues, setFormValues } = React.useContext(FormContext);

    const params = new URLSearchParams(window.location.search);

    const fieldDisabled =
        params.has("PACKAGE-ID") &&
        metadata.updatable === false;

    const rawValue = ((formValues[metadata.name] || {})["value"] || "");
    const cleanValue = rawValue.replace(/[^a-zA-Z0-9]/g, "");

    const valid =
        !metadata.required ||
        (
            cleanValue.length === 14 &&
            isValidCnpjAlfanumerico(rawValue)
        );

    const applyMask = (value) => {
        const clean = value.replace(/[^a-zA-Z0-9]/g, "").substring(0, 14);

        let masked = "";
        for (let i = 0; i < clean.length; i++) {
            if (i === 2) masked += ".";
            if (i === 5) masked += ".";
            if (i === 8) masked += "/";
            if (i === 12) masked += "-";
            masked += clean[i];
        }
        return masked;
    };

    const handleChange = (e) => {
        const masked = applyMask(e.target.value);

        const isValid = isValidCnpjAlfanumerico(masked);

        setFormValues(metadata.name, masked, isValid);
    };

    return (
        <Input
            id={metadata.name}
            name={metadata.name}
            metadata={metadata}
            value={applyMask(rawValue)}
            onChange={handleChange}
            disabled={fieldDisabled}
            valid={valid}
            maxLength={18}
        />
    );
}